export default __webpack_public_path__ + "static/realWorldImg2-e04468ddff614705993009dcd9a022e9.webp";